<template>
    <b-container fluid class="mt--7">
        <view-item
            v-if="!!item"
            :item="item"
            @success="alertSuccess"
            @delete-item="deleteType"
            @cancel="item = false"
        ></view-item>

        <list-items
            v-else
            title="Item Types"
            :items="items"
            @show-item="showItem"
            ref="table"
        >
            <b-row>
                <b-col offset="8" class="text-right">
                    <b-button variant="primary" @click="item = {}"
                        >Add Type</b-button
                    >
                </b-col>
            </b-row>
        </list-items>
    </b-container>
</template>
<script>
import ListItems from './ListItems'
import ViewItem from './ViewItem'

import utilityMixins from '@/mixins/utilityMixins'
import popupMixins from '@/mixins/popupMixins'

export default {
    name: 'ItemTypes',
    components: {
        ListItems,
        ViewItem,
    },
    mixins: [popupMixins, utilityMixins],
    data: () => {
        return {
            item: null,
        }
    },
    mounted() {
        this.doSearch()
    },
    computed: {
        items() {
            const items = this.$store.state.itemType.items
            console.log('items', items)
            return items.map(x => {
                x.is_task = !!x.is_task
                x.is_order_item = !!x.is_order_item
                //x.is_asset = !!x.is_asset
                x.is_discount = !!x.is_discount
                return x
            })
        },
    },

    methods: {
        doSearch() {
            this.$store.dispatch('itemType/fetchAll')
        },

        showItem(id) {
            this.item = this.items.find(x => x.id === id)
        },

        alertSuccess(message) {
            this.doToast('Success', `Item ${message}!`, 'success')
            this.item = null
            this.doSearch()
        },
    },
}
</script>
<style></style>
